var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCalendarGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24675_149095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7365 4.26273L9.47337 3.78906L4.26282 4.26273L3.78906 8.99961L4.26273 13.7365L8.99961 14.3286L13.7365 13.7365L14.2102 8.88126L13.7365 4.26273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20571 11.6141C5.85165 11.3748 5.60649 11.0255 5.47266 10.5637L6.29454 10.225C6.36915 10.5092 6.49938 10.7294 6.68532 10.8858C6.87009 11.0421 7.09509 11.1191 7.35798 11.1191C7.62681 11.1191 7.85775 11.0373 8.05071 10.8739C8.24367 10.7105 8.34087 10.502 8.34087 10.2498C8.34087 9.99171 8.23899 9.78084 8.03532 9.61749C7.83165 9.45414 7.57587 9.37233 7.27032 9.37233H6.79548V8.55882H7.22172C7.48461 8.55882 7.7061 8.48781 7.8861 8.3457C8.0661 8.20359 8.1561 8.00937 8.1561 7.76187C8.1561 7.54164 8.07555 7.36632 7.91454 7.23492C7.75353 7.10352 7.54977 7.03719 7.30227 7.03719C7.06071 7.03719 6.86883 7.10118 6.72672 7.23024C6.58461 7.3593 6.48156 7.51797 6.41649 7.70508L5.60298 7.36641C5.71071 7.06086 5.90853 6.79086 6.1986 6.55758C6.48876 6.3243 6.85938 6.20703 7.30938 6.20703C7.64211 6.20703 7.94172 6.27102 8.20704 6.40008C8.47227 6.52914 8.68071 6.70797 8.8311 6.93531C8.98149 7.16382 9.0561 7.41969 9.0561 7.70382C9.0561 7.99398 8.98626 8.23905 8.84649 8.44038C8.70672 8.64171 8.535 8.79561 8.33133 8.90343V8.95194C8.60016 9.06444 8.81922 9.23616 8.99211 9.4671C9.16383 9.69804 9.25023 9.97398 9.25023 10.2961C9.25023 10.6182 9.16851 10.9059 9.00507 11.1582C8.84163 11.4105 8.61546 11.6094 8.3289 11.7538C8.04117 11.8983 7.71789 11.9717 7.35906 11.9717C6.94344 11.9729 6.55977 11.8533 6.20571 11.6141Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2492 7.53555L10.3516 8.18805L9.90039 7.5036L11.5192 6.33594H12.1398V11.8437H11.2492V7.53555Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7364 17.9995L17.9995 13.7364L15.868 12.7891L13.7364 13.7364L12.7891 15.868L13.7364 17.9995Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31641 15.8698L4.26375 18.0014H13.7374V13.7383H4.26375L3.31641 15.8698Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42101 0C0.63594 0 0 0.63594 0 1.42101V13.7368L2.13156 14.6841L4.26312 13.7368V4.26312H13.7368L14.6841 2.13156L13.7369 0H1.42101Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.7383V16.5804C0 17.3656 0.63594 18.0014 1.42101 18.0014H4.26312V13.7383H0Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7363 4.26375V13.7374H17.9994V4.26375L15.8679 3.31641L13.7363 4.26375Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9994 4.26312V1.42101C17.9994 0.63585 17.3635 0 16.5784 0H13.7363V4.26312H17.9994Z",
    fill: "#1967D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24675_149095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarGoogle);
export default __webpack_public_path__ + "static/media/ic_calendar_google.8c97b5eaae3341d19f98217002012349.svg";
export { ForwardRef as ReactComponent };